import React, { useEffect, useRef, useState } from 'react'
// import RegionsPlugin from 'wavesurfer.js/dist/plugin/wavesurfer.regions.min'
// import TimelinePlugin from 'wavesurfer.js/dist/plugin/wavesurfer.timeline.min'
// import { WaveSurfer, WaveForm, Region } from 'wavesurfer-react'
import { useEvent } from '../hooks'
import { useLoopForTwoSounds } from './useLoopForTwoSounds'
import mine from '../Exhibition2/room1/mine.jpeg'
import watchmaker from '../Exhibition2/room4/watchmaker.jpeg'
import wool from '../Exhibition2/room3/wool.jpg'
import lighthouse from '../Exhibition2/room7/lighthouse.jpg'
import honey from '../Exhibition2/room6/honey.jpg'
import salt from '../Exhibition2/room5/salt.jpg'
import shepherd from '../Exhibition2/room2/shepherd.jpg'

const WAVE_IMAGES = {
  mine,
  watchmaker,
  shepherd,
  wool,
  lighthouse,
  honey,
  salt,
}

const SoundWave = ({
  data,
  setWaveImgLoaded,
  waveImgLoaded,
  setBgSoundLoaded,
  bgSoundLoaded,
  shortSoundsLoaded,
  activeImg,
  userClicked,
  pageName,
}) => {
  const wavesurferRef = useRef()
  // const [playbackRate, setRate] = useState(1)
  const { activeSoundLoaded } = useLoopForTwoSounds(data[0].bgSound, shortSoundsLoaded && userClicked, pageName)
  // const activeSoundLoaded = true

  const handleWSMount = (waveSurfer) => {
    wavesurferRef.current = waveSurfer
    if (wavesurferRef.current) {
      wavesurferRef.current.load(data[0].wave)

      wavesurferRef.current.on('ready', () => {
        // console.log(playbackRate, 'first')
        // wavesurferRef.current.setPlaybackRate(1.2)
        console.log('WaveSurfer is ready')
        setWaveImgLoaded(true)
        wavesurferRef.current.toggleMute()
      })

      wavesurferRef.current.on('loading', (data) => {
        console.log('loading --> ', data)
      })
    }
  }

  // useEffect(() => {
  //   console.log(playbackRate)
  //   const newRate = playbackRate + 0.2 / data.length
  //   console.log(newRate)
  //   setRate(newRate)
  //   wavesurferRef.current.setPlaybackRate(newRate)
  // }, [activeImg, data])

  useEffect(() => {
    if (activeSoundLoaded) {
      console.log('setBgTrue')
      setBgSoundLoaded(true)
    }
  }, [activeSoundLoaded])

  useEffect(() => {
    // if (bgSoundLoaded && waveImgLoaded && shortSoundsLoaded) {
    //   wavesurferRef.current.play()
    // }
    if (bgSoundLoaded) {
      console.log('bg sound loaded, wave should start', bgSoundLoaded)
    }
  }, [bgSoundLoaded, waveImgLoaded, shortSoundsLoaded])

  const [pause, setPause] = useState(false)
  const onPausePlay = () => {
    setPause((prev) => !prev)
    if (pause) {
      wavesurferRef.current.play()
      // howlRef.current.play()
      // howlRef.current.fade(0, 1, 1000)
    } else {
      setTimeout(() => {
        wavesurferRef.current.pause()
        // howlRef.current.pause()
      }, 1000)
      // howlRef.current.fade(1, 0, 1000)
    }
  }
  const checkKey = (e) => {
    if (e.keyCode === 32) {
      onPausePlay()
    }
  }
  // useEvent('keydown', checkKey)
  return <img src={WAVE_IMAGES[pageName]} alt="sound wave" className="waveImg" />
  {
    /*<WaveSurfer onMount={handleWSMount}>*/
  }
  {
    /*  <WaveForm*/
  }
  {
    /*    id="waveform"*/
  }
  {
    /*    waveColor="black"*/
  }
  {
    /*    progressColor="black"*/
  }
  {
    /*    barHeight={9}*/
  }
  {
    /*    height={147}*/
  }
  {
    /*    cursorColor="transparent"*/
  }
  {
    /*  >*/
  }
  {
    /*    /!*{regions.map((regionProps) => (*!/*/
  }
  {
    /*    /!*  <Region key={regionProps.id} {...regionProps} />*!/*/
  }
  {
    /*    /!*))}*!/*/
  }
  {
    /*  </WaveForm>*/
  }
  {
    /*  /!*<div id="timeline" />*!/*/
  }
  {
    /*</WaveSurfer>*/
  }
  {
    /*<button onClick={onPausePlay}>Pause</button>*/
  }
}

export default SoundWave

// const plugins = [
//   {
//     plugin: RegionsPlugin,
//     options: { dragSelection: false },
//   },
//   {
//     plugin: TimelinePlugin,
//     options: {
//       container: '#timeline',
//     },
//   },
// ].filter(Boolean)

// const [regions] = useState([
// {
//   id: 'region-1',
//   start: 0.5,
//   end: 10,
//   color: 'rgba(0, 0, 0, .5)',
//   data: {
//     systemRegionId: 31,
//   },
// },
// {
//   id: 'region-2',
//   start: 5,
//   end: 25,
//   color: 'rgba(225, 255, 255, .5)',
//   data: {
//     systemRegionId: 32,
//   },
// },
// {
//   id: 'region-3',
//   start: 15,
//   end: 35,
//   color: 'rgba(25, 95, 195, .5)',
//   data: {
//     systemRegionId: 33,
//   },
// },
// ])
